













































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { UnitBaseData, emptyData } from '@/api/heritageUnit/unitBase'
import UnitPositionsView from '@/components/heritageUnit/view/positions.vue'
// import UnitActionsView from '@/components/heritageUnit/view/actions.vue'

@Component({
  components: { UnitPositionsView }
})
export default class OtherUnitBaseView extends Vue {
  public name = 'OtherUnitBaseView'
  public expandNames: string[] = ['base']
  @Prop({ default: null })
  public formData: UnitBaseData = Object.assign({}, emptyData)
  @Prop({ default: false })
  public loading: boolean = false

  public $refs!: {
  }
  get form(): UnitBaseData {
    var f = this.formData
    return f
  }
}
